import { render, staticRenderFns } from "./PlayerSelector.vue?vue&type=template&id=560cec7d&"
import script from "./PlayerSelector.vue?vue&type=script&lang=js&"
export * from "./PlayerSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports